<script>
// import ChartHeatmap from '@components/charts/chart-heatmap.vue'
import ChartHeatmap from '@components/charts/chart-heatmap-js.vue'
import WidgetCard from '@widgets/widget-card.vue'

export default {
  components: {
    ChartHeatmap,
    WidgetCard,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
    },
    sheetClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
    }
  },
}
</script>

<template>
  <WidgetCard
    :title="$t('heatmap_graph_widget_title')"
    :loading="loading"
    :sheet-class="sheetClass"
  >
    <ChartHeatmap
      v-show="!loading"
      :player-id="playerId"
      @loaded="loading = false"
    />
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.heatmapGraph {
  height: 20rem;
}
</style>
